export default __webpack_public_path__ + "static/assets/075745c9ac5592d1418af837cf20115e.png";